import { useState } from "react";

// react-router-dom components
import { useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import axios from "axios";
import { CircularProgress, FormHelperText } from "@mui/material";
import { isEmpty } from "validator";
import MDButton from "components/MDButton";

// json web token
// eslint-disable-next-line camelcase
import jwt_decode from "jwt-decode";

// Service
import { login } from "services/authentication/auth";

// Constants
import { SERVER_ERROR } from "constants/messages/error";
import { isValidPhoneOrEmail } from "constants/utils/validator";

function Basic() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [usernameError, setUsernameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const validCredentials = () => isValidPhoneOrEmail(username) && password.length >= 4;

  const handleSignIn = (e) => {
    e.preventDefault();
    if (!isValidPhoneOrEmail(username)) setUsernameError(true);
    if (password.length < 4) setPasswordError(true);
    if (!validCredentials()) {
      setError("Numéro téléphone/E-amil et/ou mot de passe invalide !");
      return;
    }
    setLoading(true);

    login({ username, password })
      .then(({ data }) => {
        if (jwt_decode(data.token).roles.includes("ROLE_SUBSCRIBER")) {
          setError("Accès réfusé");
        } else {
          localStorage.setItem("token", data.token);
          localStorage.setItem("refresh_token", data.refresh_token);
          setError(false);
          axios.defaults.headers.common.Authorization = `Bearer ${data.token}`;
          navigate("/lessons");
        }
      })
      .catch((err) =>
        err.request.status ? setError(err.response.data.message) : setError(SERVER_ERROR)
      )
      .finally(() => setLoading(false));
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Connexion
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSignIn} noValidate autoComplete="off">
            <MDBox mb={2}>
              <MDInput
                required
                type="text"
                label="Tel ou e-mail"
                error={setUsernameError}
                value={username}
                disabled={loading}
                onChange={(e) => {
                  if (error) setError(false);
                  setUsername(e.target.value);
                  // eslint-disable-next-line no-unused-expressions
                  !isValidPhoneOrEmail(e.target.value)
                    ? setUsernameError(true)
                    : setUsernameError(false);
                }}
                onBlur={() => isEmpty(username) && setUsernameError(false)}
                fullWidth
              />
              {usernameError && (
                <FormHelperText error>
                  Saisir un numéro de téléphone ou E-mail valide . ex: +261 22222222
                </FormHelperText>
              )}
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                required
                error={passwordError}
                disabled={loading}
                type="password"
                label="Mot de passe"
                value={password}
                placeholder="Saisir votre mot de passe"
                onChange={(e) => {
                  if (error) setError(false);
                  setPassword(e.target.value);
                  // eslint-disable-next-line no-unused-expressions
                  e.target.value.length < 4 ? setPasswordError(true) : setPasswordError(false);
                }}
                onBlur={() => isEmpty(password) && setPasswordError(false)}
                fullWidth
              />
              {passwordError && (
                <FormHelperText error>Doit contenir 4 caractères ou plus</FormHelperText>
              )}
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton type="submit" disabled={loading} variant="gradient" color="info" fullWidth>
                <span style={{ opacity: loading ? 0.2 : 1 }}>se connecter</span>
                {loading && (
                  <CircularProgress size={30} color="dark" style={{ position: "absolute" }} />
                )}
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1}>
              {error && <FormHelperText error>{error}</FormHelperText>}
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
